import { render, staticRenderFns } from "./DossierItem.vue?vue&type=template&id=31802af0&scoped=true&"
import script from "./DossierItem.vue?vue&type=script&lang=js&"
export * from "./DossierItem.vue?vue&type=script&lang=js&"
import style0 from "./DossierItem.vue?vue&type=style&index=0&id=31802af0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31802af0",
  null
  
)

export default component.exports